<template>
    <v-container style="padding:0px; margin:0px">
        <v-card style="background-color: white; padding:10px; margin:0px">
            <v-row>
                <v-col>
                    <h3>Configuración secuencia</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-text-field
                        v-model="sequence.code"
                        label="Nombre secuencia"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-model="next"
                        label="Próximo número"
                        outlined
                        :readonly="Boolean(sequence.id)"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4">
                    <v-text-field
                        v-model="sequence.prefix"
                        label="Prefijo"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field
                        v-model="sequence.fill"
                        label="Relleno"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field
                        v-model="sequence.suffix"
                        label="Sufijo"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    Siguiente identificador: <b>{{ previewNum }} </b> 
                </v-col>
                
            </v-row>
            <v-row>
                <v-col cols="9">
                    <v-btn @click="cancel" color="gray">Cancelar</v-btn>
                </v-col>
                <v-col cols="3">
                    <v-btn @click="save" color="primary">Guardar</v-btn>
                </v-col>
            </v-row>
        </v-card>
        
    </v-container>
</template>

<script>

export default {
    name: 'SequenceConfig',
    components: {
    },
    props:{
        sequence:{
            type: [Object],
            required: true,
            default: null
        },
    },
    data(){
        return {
            next: 0
        }
    },
    mounted(){
        if(this.sequence){
            this.next = Number.parseInt(this.sequence.current) +1;
        }
    },
    methods:{
        save(){
            this.sequence.current = Number.parseInt(this.next) - 1;
            this.$emit('save-seq');
        },
        cancel(){
            this.$emit('cancel');
        },
    },
    computed:{
        previewNum(){
            let num = Number.parseInt(this.sequence.current) + 1;
            return `${this.sequence.prefix}${num.toString().padStart(this.sequence.fill, '0')}${this.sequence.suffix}`;
        },
        allowSave(){
            return this.sequence.code && this.sequence.fill;
        }
    }

}
</script>

<style>

</style>